<template>
  <button
    :class="{ 'button': true, 'button--inverse': isInverse }"
    :disabled="isSaving || isDisabled"
    :type="type"
  >
    <span :class="{ hidden: isSaving }">{{ buttonLabelText }}</span>
    <Loader
      v-if="isSaving"
      :modifiers="['overlay']"
    />
  </button>
</template>

<script setup>
import { computed } from 'vue';
import I18n from 'i18n-js';

import Loader from '@/components/generic/loader.vue';

const props = defineProps({
  /** Used to render custom label text. */
  buttonLabel: { type: String, default: null },
  /** If set to true the button will have a loader and be disabled. This ensures that the user cannot submit a form multiple times. The isSaving prop is typically set before and after the API response. */
  isSaving: { type: Boolean, default: false },
  /** If set to true the button will be disabled. Used for instances where the form should not allow saving until there are changes. */
  isDisabled: { type: Boolean, default: false },
  /** Used to set the button to a different type */
  type: { type: String, default: 'submit' },
  /** Used to change the style for the button */
  isInverse: { type: Boolean, default: true },
});

const buttonLabelText = computed(
  () => props.buttonLabel || I18n.t('general.save')
);
</script>

<style lang="scss">
@import '@/stylesheets/global';
@import '@/stylesheets/components/form/button';
</style>
